import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	disabledAutomationMenuButtonTooltipMessage: {
		id: 'software-releases-automation-menu.disabled-automation-menu-button-tooltip-message',
		defaultMessage: 'You need to be a project admin to configure automation',
		description: "A tooltip message to show when user don't have permession to manage automation",
	},
	automationMenuTitle: {
		id: 'software-releases-automation-menu.automation-menu-title',
		defaultMessage: 'Automation',
		description: 'Title of the automation menu',
	},
	automationMenuSubTitle: {
		id: 'software-releases-automation-menu.automation-menu-sub-title',
		defaultMessage:
			'Setup your release automations from these templates, or create a new one of your own.',
		description: 'A short message explaining purpose of the automation menu',
	},
});
